import request from '@/utils/request'

export function login(email, password) {
  const data = {
    email,
    password
  }
  return request({
    url: '/adminLogin',
    method: 'post',
    data
  })
}

export function sendOtp(id_number) {
  const data = {
    id_number
  }
  return request({
    url: '/sendOtp',
    method: 'post',
    data
  })
}

export function verifyOtp(id_number, otp) {
  const data = {
    id_number,
    otp
  }
  return request({
    url: '/verifyOtp',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: 'logout',
    method: 'post'
  });
}
